import normalize from "jsonapi-normalizer";
import { makeAutoObservable } from "mobx";
import { AuthContext } from "../../typings/context";
import { UsersApi } from "../../../api/users/UsersApi";
import {
  PasswordTokenRequest,
  GrantType,
  AuthApi,
  RefreshTokenRequest,
  OauthTokenResponse,
} from "../../../api/users/AuthApi";
import { setRefreshToken, setAccessToken } from "../../../helpers/cookies";
import { LoginOptions } from "../../stores/AuthStore/AuthStore";

export class AuthService {
  constructor(private readonly ctx: AuthContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  me = async () => {
    const response = await UsersApi.me({
      include: ["profiles", "permissions"],
    });
    const { users, permissions } = normalize(response).entities;
    this.ctx.permissions = { ...permissions };
    this.ctx.authenticatedUser = users;
  };

  login = async (data: LoginOptions) => {
    const { rememberMe, username, password } = data;
    const loginData: PasswordTokenRequest = {
      client_id: process.env.REACT_APP_CLIENT_ID!,
      client_secret: process.env.REACT_APP_CLIENT_SECRET!,
      username,
      password,
      grant_type: GrantType.password,
      scope: "users.users.own.read" +
        " users.users.own.update" +
        " users.users.own.delete" +
        " users.users.any.create" +
        " users.users.any.read" +
        " users.users.any.update" +
        " users.users.any.delete" +
        " users.users_profiles_roles_permissions.any.create" +
        " users.users_profiles_roles_permissions.any.read" +
        " users.users_profiles_roles_permissions.any.delete",
    };
    const response = await AuthApi.login(loginData);
    const { access_token, expires_in, refresh_token } = response;
    setRefreshToken(refresh_token, { path: "/" });
    setAccessToken(access_token, {
      expires_in,
    });
    this.ctx.isLogged = true;
    localStorage.setItem("rememberMe", JSON.stringify(rememberMe));
    if (rememberMe) {
      localStorage.setItem("username", username);
    } else {
      localStorage.removeItem("username");
    }
  };

  token = async (token: string) => {
    const refreshTokenData: RefreshTokenRequest = {
      client_id: process.env.REACT_APP_CLIENT_ID!,
      client_secret: process.env.REACT_APP_CLIENT_SECRET!,
      refresh_token: token,
      grant_type: GrantType.token,
    };
    const response: OauthTokenResponse = await AuthApi.token(refreshTokenData);
    const { access_token, expires_in, refresh_token } = response;
    setRefreshToken(refresh_token, { path: "/" });
    setAccessToken(access_token, {
      expires_in,
    });
    this.ctx.isLogged = true;
  };
}
